import MPDropdownRoot from './MPDropdown.vue';
import MPDropdownTrigger from './MPDropdownTrigger.vue';
import MPDropdownContent from './MPDropdownContent.vue';
import MPDropdownItem from './MPDropdownItem.vue';
import MPDropdownGroup from './MPDropdownGroup.vue';
import MPDropdownLabel from './MPDropdownLabel.vue';
import MPDropdownSeparator from './MPDropdownSeparator.vue';
import MPDropdownSub from './MPDropdownSub.vue';
import MPDropdownSubTrigger from './MPDropdownSubTrigger.vue';
import MPDropdownSubContent from './MPDropdownSubContent.vue';

export const MPDropdown = {
    Root: MPDropdownRoot,
    Trigger: MPDropdownTrigger,
    Content: MPDropdownContent,
    Item: MPDropdownItem,
    Group: MPDropdownGroup,
    Label: MPDropdownLabel,
    Separator: MPDropdownSeparator,
    Sub: MPDropdownSub,
    SubTrigger: MPDropdownSubTrigger,
    SubContent: MPDropdownSubContent,
};

export {
    MPDropdownRoot,
    MPDropdownTrigger,
    MPDropdownContent,
    MPDropdownItem,
    MPDropdownGroup,
    MPDropdownLabel,
    MPDropdownSeparator,
    MPDropdownSub,
    MPDropdownSubTrigger,
    MPDropdownSubContent,
};
